import { baseUrl } from "./api";

export async function getTermsCondition() {
  const origin = new URL(baseUrl).origin;
  const res = await fetch(`${origin}/uploads/cmspages/termscondition.html`);
  return res.text();
}
